module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Discovery-Of-Witches-A-S1.9a4c069.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Discovery-Of-Witches-A-S1.jpg
// module id = OC7i
// module chunks = 0